import React, {Component} from 'react';
import {SettingsView} from '../../common/LocalSettings/LocalSettings';
import TabsRenderer from '../../common/TabsRenderer';
import {UserRoles} from "../../common/Constants";
import TTLProxy from "../../common/TTLAsyncProxy";

const TaskBlock = (props) => {
    return (<div>
        <div className="callout m-0 py-2 text-muted text-center bg-faded text-uppercase">
            <small><b>Today</b></small>
        </div>
        <hr className="transparent mx-3 my-0"/>
        <div className="callout callout-warning m-0 py-3">
            <div className="avatar float-right">
                <img src={'img/avatars/7.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>
            </div>
            <div>Meeting with <strong>Lucas</strong></div>
            <small className="text-muted mr-3"><i className="icon-calendar"></i>&nbsp; 1 - 3pm</small>
            <small className="text-muted"><i className="icon-location-pin"></i>&nbsp; Palo Alto, CA </small>
        </div>
        <hr className="mx-3 my-0"/>
        <div className="callout callout-info m-0 py-3">
            <div className="avatar float-right">
                <img src={'img/avatars/4.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>
            </div>
            <div>Skype with <strong>Megan</strong></div>
            <small className="text-muted mr-3"><i className="icon-calendar"></i>&nbsp; 4 - 5pm</small>
            <small className="text-muted"><i className="icon-social-skype"></i>&nbsp; On-line </small>
        </div>
    </div>);
};

const ChatMessage = (props) => {
    return  (<div className="message">
        <div className="py-3 pb-5 mr-3 float-left">
            <div className="avatar">
                <img src={props.senderMedia} className="img-avatar" alt="admin@bootstrapmaster.com"/>
                <span className="avatar-status badge-success"></span>
            </div>
        </div>
        <div>
            <small className="text-muted">{props.sender}</small>
            <small className="text-muted float-right mt-1">{props.date}</small>
        </div>
        <div className="text-truncate font-weight-bold">{props.title}</div>
        <small className="text-muted">{props.content}</small>
    </div>);
};

const SettingsTab = {
    icon: "icon-settings",
    render: () => {
        return <div className="p-3">
            <h6>Settings</h6>
            <SettingsView />
        </div>;
    }
};


class Aside extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userRole : TTLProxy.getInstance().getUserRole()
        };

    }

    getForUser(){

        switch (this.state.userRole){
            case UserRoles.Admin:
                return [
                    /*{
                        icon: "icon-list",
                        render: () => {
                           return <div className="p-3">
                                <p className="text-muted">No tasks available yet!</p>
                           </div>;
                        }
                    },
                    {
                        icon: "icon-speech",
                        render: () => {
                            return <div className="p-3">  <p className="text-muted">No chat messages yet!</p> </div>;
                        }
                    },*/
                    SettingsTab

                ];
            case UserRoles.FBO:
                return [
                    SettingsTab
                ];
            case UserRoles.Owner:
                return [
                    SettingsTab
                ];
            case UserRoles.Farmer:
                return  [
                    SettingsTab
                ];
        }
    }

    componentWillMount(){
        this.tabs = this.getForUser();
    }

    render() {

        return (
            <aside className="aside-menu">
                <TabsRenderer pages={this.tabs} defaultPage={0} />
            </aside>
        )
    }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js